
// import React, { useState, useEffect } from 'react';
// import '../../Styles/ManagementPages.css';
// import { 
//   createInfluencer, 
//   getInfluencers, 
//   getInfluencerById, 
//   updateInfluencer, 
//   deleteInfluencer,
//   updateInfluencerStatus 
// } from '../../Services/Operations/ProductAPI';
// import { useSelector } from 'react-redux';

// /* ============================================================
//  * MODERN UI PRIMITIVES (mirror PrimaryRouteManage.css)
//  * ============================================================ */
// const ICON_PATHS = {
//     route: 'M5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M19 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4z M7 17h7a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h7',
//     check: 'M22 11.1V12a10 10 0 1 1-5.9-9.1 M22 4 12 14l-3-3',
//     calendar: 'M8 2v4 M16 2v4 M3 10h18 M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z',
//     pin: 'M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 1 1 16 0z M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
//     clock: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 6v6l4 2',
//     stop: 'M12 3v18 M5 6h11l3 3-3 3H5z',
//     search: 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z M21 21l-4.3-4.3',
//     eye: 'M2 12s4-8 10-8 10 8 10 8-4 8-10 8S2 12 2 12z M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
//     trash: 'M3 6h18 M8 6V4h8v2 M6 6l1 14h10l1-14 M10 11v6 M14 11v6',
//     grid: 'M3 3h7v7H3z M14 3h7v7h-7z M14 14h7v7h-7z M3 14h7v7H3z',
//     list: 'M8 6h13 M8 12h13 M8 18h13 M3 6h.01 M3 12h.01 M3 18h.01',
//     tag: 'M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z M7.5 7.5h.01',
//     plus: 'M12 5v14 M5 12h14',
//     map: 'M1 6l7-3 8 3 7-3v15l-7 3-8-3-7 3z M8 3v15 M16 6v15',
//     bus: 'M5 3h14a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z M3 11h18 M7 21v-3 M17 21v-3 M7 15h.01 M17 15h.01',
//     edit: 'M12 20h9 M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z',
//     info: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z M12 16v-4 M12 8h.01',
//     refresh: 'M23 4v6h-6 M1 20v-6h6 M3.5 9a9 9 0 0 1 14.9-3.4L23 10 M1 14l4.6 4.4A9 9 0 0 0 20.5 15',
//     x: 'M18 6 6 18 M6 6l12 12'
// };

// const Icon = ({ name, size = 18 }) => (
//     <svg className="prm-ico" viewBox="0 0 24 24" width={size} height={size} fill="none"
//         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
//         <path d={ICON_PATHS[name]} />
//     </svg>
// );

// const BusSvg = ({ size = 34 }) => (
//     <svg viewBox="0 0 64 34" width={size} height={(size * 34) / 64} aria-hidden="true">
//         <rect x="2" y="3" width="58" height="23" rx="7" fill="#f59e0b" />
//         <rect x="2" y="19" width="58" height="4" fill="#d97706" />
//         <rect x="8" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
//         <rect x="19" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
//         <rect x="30" y="8" width="8" height="8" rx="2" fill="#0b1f44" />
//         <path d="M43 8h10a4 4 0 0 1 4 4v4H43z" fill="#0b1f44" />
//         <rect x="57" y="20" width="4" height="3" rx="1" fill="#fff7d6" />
//         <circle cx="17" cy="27" r="5.5" fill="#0b1f44" /><circle cx="17" cy="27" r="2.2" fill="#cbd5e1" />
//         <circle cx="46" cy="27" r="5.5" fill="#0b1f44" /><circle cx="46" cy="27" r="2.2" fill="#cbd5e1" />
//     </svg>
// );

// const useCountUp = (target, duration = 900) => {
//     const [value, setValue] = useState(0);
//     useEffect(() => {
//         let raf, start;
//         const step = (t) => {
//             if (!start) start = t;
//             const p = Math.min((t - start) / duration, 1);
//             setValue(Math.round(target * (1 - Math.pow(1 - p, 3))));
//             if (p < 1) raf = requestAnimationFrame(step);
//         };
//         raf = requestAnimationFrame(step);
//         return () => cancelAnimationFrame(raf);
//     }, [target, duration]);
//     return value;
// };

// const StatCard = ({ icon, label, value, hint, tone, delay = 0 }) => {
//     const shown = useCountUp(value);
//     return (
//         <div className={`prm-stat tone-${tone}`} style={{ animationDelay: `${delay}ms` }}>
//             <div className="prm-stat-icon"><Icon name={icon} size={24} /></div>
//             <div className="prm-stat-body">
//                 <div className="prm-stat-label">{label}</div>
//                 <div className="prm-stat-value">{shown}</div>
//                 <div className="prm-stat-hint">{hint}</div>
//             </div>
//         </div>
//     );
// };

// const Switch = ({ checked, onChange, title }) => (
//     <label className="prm-switch" title={title}>
//         <input type="checkbox" checked={checked} onChange={onChange} />
//         <span />
//     </label>
// );

// const FormSection = ({ n, title, hint, children, delay = 0 }) => (
//     <section className="prm-fsec" style={{ animationDelay: `${delay}ms` }}>
//         <header className="prm-fsec-head">
//             <span className="prm-fsec-num">{n}</span>
//             <div>
//                 <h4>{title}</h4>
//                 {hint && <p>{hint}</p>}
//             </div>
//         </header>
//         <div className="prm-fsec-body">{children}</div>
//     </section>
// );

// const Field = ({ label, required, children, full, note }) => (
//     <div className={`prm-field ${full ? 'full' : ''}`}>
//         {label && <label className="prm-label">{label}{required && <em>*</em>}</label>}
//         {children}
//         {note && <small className="prm-note">{note}</small>}
//     </div>
// );

// const PrmCheckbox = ({ label, checked, onChange }) => (
//     <label className={`prm-check ${checked ? 'on' : ''}`}>
//         <input type="checkbox" checked={checked} onChange={onChange} />
//         <span className="box"><Icon name="check" size={12} /></span>
//         <span className="txt">{label}</span>
//     </label>
// );

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>Influencer</th>
//           <th>Contact</th>
//           <th>Commission Rate</th>
//           <th>Referrals</th>
//           <th>Earnings</th>
//           <th>Joined</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonFilterPanel = () => (
//   <div className="filter-panel skeleton">
//     <div className="filter-header">
//       <div className="skeleton-title"></div>
//       <div className="skeleton-close"></div>
//     </div>
//     <div className="filter-grid">
//       {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
//         <div key={i} className="filter-group">
//           <div className="skeleton-label"></div>
//           <div className="skeleton-input"></div>
//         </div>
//       ))}
//     </div>
//     <div className="filter-actions">
//       <div className="skeleton-button"></div>
//       <div className="skeleton-button"></div>
//     </div>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((i) => (
//           <div key={i} className="skeleton-detail-row">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-value"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const InfluencerManage = () => {
//   const [influencers, setInfluencers] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [searching, setSearching] = useState(false);
//   const [editingInfluencer, setEditingInfluencer] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingInfluencer, setViewingInfluencer] = useState(null);
//   const [showAddModal, setShowAddModal] = useState(false);
//   const [processingPayout, setProcessingPayout] = useState(null);
//   const [isLoading, setIsLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const [isFetchingDetails, setIsFetchingDetails] = useState(false);
//   const [newInfluencer, setNewInfluencer] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     commissionRate: 10
//   });

//   const { token } = useSelector(state => state.user);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalInfluencers, setTotalInfluencers] = useState(0);
//   const [pageSize] = useState(10);

//   const [filters, setFilters] = useState({
//     status: 'All Status',
//     name: '',
//     email: '',
//     phone: '',
//     referralCode: '',
//     minCommission: '',
//     maxCommission: '',
//     minEarnings: '',
//     maxEarnings: '',
//     dateFrom: '',
//     dateTo: ''
//   });
//   const [showFilters, setShowFilters] = useState(false);
//   const [isFiltered, setIsFiltered] = useState(false);

//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchInfluencers();
//     }, 500);

//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm, filters]);

//   const fetchInfluencers = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       setError(null);
      
//       const filterParams = {};
      
//       if (searchTerm) {
//         filterParams.search = searchTerm;
//       }
      
//       Object.keys(filters).forEach(key => {
//         if (filters[key] && filters[key] !== 'All Status') {
//           filterParams[key] = filters[key];
//         }
//       });

//       const params = {
//         page: currentPage,
//         limit: pageSize,
//         ...filterParams
//       };

//       console.log('Fetching influencers with params:', params);

//       const response = await getInfluencers(token, params);
//       if (response && response.influencers) {
//         const influencersWithDefaults = response.influencers.map(infl => ({
//           ...infl,
//           isActive: infl.isActive !== undefined ? infl.isActive : true,
//           stats: infl.stats || {
//             totalEarnings: 0,
//             pendingEarnings: 0,
//             totalReferrals: 0
//           }
//         }));
//         setInfluencers(influencersWithDefaults);
        
//         if (response.totalPages) {
//           setTotalPages(response.totalPages);
//         }
//         if (response.total) {
//           setTotalInfluencers(response.total);
//         }

//         const hasActiveFilters = 
//           filters.status !== 'All Status' || 
//           searchTerm !== '' || 
//           Object.values(filters).some(value => 
//             value && value !== '' && value !== 'All Status'
//           );
//         setIsFiltered(hasActiveFilters);
//       } else {
//         setError('Failed to fetch influencers.');
//         setInfluencers([]);
//       }
//     } catch (err) {
//       console.error('Error fetching influencers:', err);
//       setError('Failed to fetch influencers. Please try again.');
//       setInfluencers([]);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const fetchInfluencerById = async (id) => {
//     try {
//       const response = await getInfluencerById(id, token);
//       return response;
//     } catch (error) {
//       console.error('Error fetching influencer:', error);
//       throw error;
//     }
//   };

//   const getSafeString = (value) => {
//     if (value === null || value === undefined) return '';
//     return String(value);
//   };

//   const getSafeNumber = (value) => {
//     if (value === null || value === undefined) return 0;
//     return Number(value);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleSearchSubmit = (e) => {
//     e.preventDefault();
//     setCurrentPage(1);
//     fetchInfluencers();
//   };

//   const handleFilterChange = (e) => {
//     const { name, value } = e.target;
//     setFilters(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const applyFilters = () => {
//     setCurrentPage(1);
//     fetchInfluencers();
//     setShowFilters(false);
//   };

//   const clearFilters = () => {
//     setFilters({
//       status: 'All Status',
//       name: '',
//       email: '',
//       phone: '',
//       referralCode: '',
//       minCommission: '',
//       maxCommission: '',
//       minEarnings: '',
//       maxEarnings: '',
//       dateFrom: '',
//       dateTo: ''
//     });
//     setSearchTerm('');
//     setCurrentPage(1);
//     setIsFiltered(false);
//   };

//   const toggleFilters = () => {
//     setShowFilters(!showFilters);
//   };

//   const handleExportCSV = () => {
//     if (influencers.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Name', 'Email', 'Phone', 'Referral Code', 'Commission Rate', 'Total Referrals', 'Total Earnings', 'Pending Earnings', 'Status', 'Joined Date'];
//     const csvData = influencers.map(influencer => [
//       influencer.name || '',
//       influencer.email || '',
//       influencer.phone || '',
//       influencer.referralCode || '',
//       `${influencer.commissionRate || 0}%`,
//       influencer.stats?.totalReferrals || 0,
//       influencer.stats?.totalEarnings || 0,
//       influencer.stats?.pendingEarnings || 0,
//       influencer.isActive ? 'Active' : 'Inactive',
//       formatDate(influencer.createdAt) || ''
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `influencers-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const handleViewInfluencer = async (influencer) => {
//     try {
//       setIsFetchingDetails(true);
//       const fullInfluencerData = await fetchInfluencerById(influencer._id);
//       setViewingInfluencer(fullInfluencerData);
//     } catch (error) {
//       console.error('Error fetching influencer details:', error);
//       alert('Failed to load influencer details');
//     } finally {
//       setIsFetchingDetails(false);
//     }
//   };

//   const handleEditInfluencer = (influencer) => {
//     setEditingInfluencer(influencer._id);
//     setEditForm({ 
//       name: influencer.name,
//       email: influencer.email,
//       phone: influencer.phone,
//       commissionRate: influencer.commissionRate
//     });
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setIsLoading(true);
//       setError(null);
//       await updateInfluencer(editingInfluencer, editForm, token);
//       await fetchInfluencers();
//       setEditingInfluencer(null);
//       setEditForm({});
//       alert('Influencer updated successfully!');
//     } catch (err) {
//       console.error('Error updating influencer:', err);
//       setError('Failed to update influencer. Please try again.');
//       alert('Failed to update influencer. Please try again.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingInfluencer(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleProcessPayout = (influencer) => {
//     setProcessingPayout(influencer);
//   };

//   const handleConfirmPayout = () => {
//     setInfluencers(prevInfluencers =>
//       prevInfluencers.map(influencer =>
//         influencer._id === processingPayout._id ? { 
//           ...influencer, 
//           stats: {
//             ...influencer.stats,
//             pendingEarnings: 0
//           }
//         } : influencer
//       )
//     );
//     setProcessingPayout(null);
//     alert(`Payout processed successfully!`);
//   };

//   const handleAddInfluencer = async () => {
//     if (!newInfluencer.name || !newInfluencer.email || !newInfluencer.phone) {
//       alert('Please fill in all required fields: Name, Email, and Phone');
//       return;
//     }

//     setIsLoading(true);
//     setError(null);
    
//     try {
//       const response = await createInfluencer(newInfluencer, token);
//       await fetchInfluencers();
//       setShowAddModal(false);
//       setNewInfluencer({
//         name: '',
//         email: '',
//         phone: '',
//         commissionRate: 10
//       });
      
//       const successMessage = `Influencer created successfully!\n\nReferral Code: ${response.influencer.referralCode}\nTemporary Password: ${response.influencer.tempPassword}\n\nPlease share these credentials with the influencer.`;
//       alert(successMessage);
//     } catch (err) {
//       console.error('Error creating influencer:', err);
//       const errorMessage = err.response?.data?.message || 'Failed to create influencer. Please try again.';
//       setError(`Error: ${errorMessage}`);
//       alert(`Error: ${errorMessage}`);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleDeleteInfluencer = async (influencerId) => {
//     if (window.confirm('Are you sure you want to delete this influencer?')) {
//       try {
//         setError(null);
//         await deleteInfluencer(influencerId, token);
//         await fetchInfluencers();
//         alert('Influencer deleted successfully!');
//       } catch (err) {
//         console.error('Error deleting influencer:', err);
//         setError('Failed to delete influencer. Please try again.');
//         alert('Failed to delete influencer. Please try again.');
//       }
//     }
//   };

//   const handleToggleStatus = async (influencer) => {
//     try {
//       const newStatus = !influencer.isActive;
//       await updateInfluencerStatus(influencer._id, { isActive: newStatus }, token);
//       await fetchInfluencers();
//       alert(`Influencer ${newStatus ? 'activated' : 'deactivated'} successfully!`);
//     } catch (error) {
//       console.error('Error updating influencer status:', error);
//       alert('Failed to update influencer status');
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: name === 'commissionRate' ? parseInt(value) : value
//     }));
//   };

//   const handleNewInfluencerChange = (e) => {
//     const { name, value } = e.target;
//     setNewInfluencer(prev => ({
//       ...prev,
//       [name]: name === 'commissionRate' ? parseInt(value) : value
//     }));
//   };

//   const closeViewModal = () => {
//     setViewingInfluencer(null);
//   };

//   const closeAddModal = () => {
//     setShowAddModal(false);
//     setNewInfluencer({
//       name: '',
//       email: '',
//       phone: '',
//       commissionRate: 10
//     });
//     setError(null);
//   };

//   const closePayoutModal = () => {
//     setProcessingPayout(null);
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//     clearFilters();
//   };

//   const activeInfluencers = influencers.filter(i => i.isActive).length;
//   const totalCommission = influencers.reduce((sum, influencer) => sum + getSafeNumber(influencer.stats?.pendingEarnings), 0);
//   const totalEarnings = influencers.reduce((sum, influencer) => sum + getSafeNumber(influencer.stats?.totalEarnings), 0);
//   const totalReferrals = influencers.reduce((sum, influencer) => sum + getSafeNumber(influencer.stats?.totalReferrals), 0);

//   const generatePageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 5;
    
//     if (totalPages <= maxVisiblePages) {
//       for (let i = 1; i <= totalPages; i++) {
//         pages.push(i);
//       }
//     } else {
//       let start = Math.max(1, currentPage - 2);
//       let end = Math.min(totalPages, start + maxVisiblePages - 1);
      
//       if (end - start + 1 < maxVisiblePages) {
//         start = Math.max(1, end - maxVisiblePages + 1);
//       }
      
//       for (let i = start; i <= end; i++) {
//         pages.push(i);
//       }
//     }
    
//     return pages;
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return 'N/A';
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) {
//         return 'N/A';
//       }
//       return date.toLocaleDateString('en-GB');
//     } catch (error) {
//       console.error('Date formatting error:', error);
//       return 'N/A';
//     }
//   };

//   if (loading && influencers.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Influencer Management</h1>
//         <div className="header-actions">
//           <form onSubmit={handleSearchSubmit} className="search-form">
//             <div style={{ position: 'relative' }}>
//               <input 
//                 type="text" 
//                 placeholder="Search by name, email or phone..." 
//                 className="search-input" 
//                 value={searchTerm}
//                 onChange={handleSearchChange}
//                 style={{ width: "300px" }}
//               />
//               {searching && (
//                 <span style={{
//                   position: 'absolute', right: '10px', top: '50%',
//                   transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//                 }}>
//                   searching...
//                 </span>
//               )}
//             </div>
//           </form>
          
//           <button className="filter-btn" onClick={toggleFilters}>
//             🔍 Filters
//           </button>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//           <button className="add-btn" onClick={() => setShowAddModal(true)}>
//             + Add Influencer
//           </button>
//         </div>
//       </div>


//       {showFilters && !loading && (
//         <div className="filter-panel">
//           <div className="filter-header">
//             <h3>Filter Influencers</h3>
//             <button className="close-filters" onClick={() => setShowFilters(false)}>
//               ×
//             </button>
//           </div>
//           <div className="filter-grid">
//             <div className="filter-group">
//               <label>Name</label>
//               <input
//                 type="text"
//                 name="name"
//                 value={filters.name}
//                 onChange={handleFilterChange}
//                 placeholder="Enter name"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Email</label>
//               <input
//                 type="email"
//                 name="email"
//                 value={filters.email}
//                 onChange={handleFilterChange}
//                 placeholder="Enter email"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Phone</label>
//               <input
//                 type="text"
//                 name="phone"
//                 value={filters.phone}
//                 onChange={handleFilterChange}
//                 placeholder="Enter phone"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Referral Code</label>
//               <input
//                 type="text"
//                 name="referralCode"
//                 value={filters.referralCode}
//                 onChange={handleFilterChange}
//                 placeholder="Enter referral code"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Status</label>
//               <select
//                 name="status"
//                 value={filters.status}
//                 onChange={handleFilterChange}
//               >
//                 <option value="All Status">All Status</option>
//                 <option value="active">Active</option>
//                 <option value="inactive">Inactive</option>
//               </select>
//             </div>
//             <div className="filter-group">
//               <label>Min Commission (%)</label>
//               <input
//                 type="number"
//                 name="minCommission"
//                 value={filters.minCommission}
//                 onChange={handleFilterChange}
//                 placeholder="Minimum commission"
//                 min="0"
//                 max="100"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Max Commission (%)</label>
//               <input
//                 type="number"
//                 name="maxCommission"
//                 value={filters.maxCommission}
//                 onChange={handleFilterChange}
//                 placeholder="Maximum commission"
//                 min="0"
//                 max="100"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Min Earnings</label>
//               <input
//                 type="number"
//                 name="minEarnings"
//                 value={filters.minEarnings}
//                 onChange={handleFilterChange}
//                 placeholder="Minimum earnings"
//                 min="0"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Max Earnings</label>
//               <input
//                 type="number"
//                 name="maxEarnings"
//                 value={filters.maxEarnings}
//                 onChange={handleFilterChange}
//                 placeholder="Maximum earnings"
//                 min="0"
//               />
//             </div>
//             <div className="filter-group">
//               <label>Joined From</label>
//               <input
//                 type="date"
//                 name="dateFrom"
//                 value={filters.dateFrom}
//                 onChange={handleFilterChange}
//               />
//             </div>
//             <div className="filter-group">
//               <label>Joined To</label>
//               <input
//                 type="date"
//                 name="dateTo"
//                 value={filters.dateTo}
//                 onChange={handleFilterChange}
//               />
//             </div>
//           </div>
//           <div className="filter-actions">
//             <button className="apply-filters-btn" onClick={applyFilters}>
//               Apply Filters
//             </button>
//             <button className="clear-filters-btn" onClick={clearFilters}>
//               Clear All
//             </button>
//           </div>
//           {isFiltered && (
//             <div className="active-filters">
//               <span>Active Filters:</span>
//               {searchTerm && (
//                 <span className="filter-tag">Search: {searchTerm}</span>
//               )}
//               {filters.status !== 'All Status' && (
//                 <span className="filter-tag">Status: {filters.status}</span>
//               )}
//               {Object.entries(filters).map(([key, value]) => 
//                 value && 
//                 key !== 'status' && 
//                 key !== 'dateFrom' && 
//                 key !== 'dateTo' && (
//                   <span key={key} className="filter-tag">
//                     {key}: {value}
//                   </span>
//                 )
//               )}
//               {filters.dateFrom && (
//                 <span className="filter-tag">From: {filters.dateFrom}</span>
//               )}
//               {filters.dateTo && (
//                 <span className="filter-tag">To: {filters.dateTo}</span>
//               )}
//             </div>
//           )}
//         </div>
//       )}

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Influencers</h3>
//           <p>{totalInfluencers}</p>
//           <span>All marketing partners</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active</h3>
//           <p>{activeInfluencers}</p>
//           <span>Active influencers</span>
//         </div>
//         <div className="stat-card">
//           <h3>Pending Payout</h3>
//           <p>₹{totalCommission.toLocaleString()}</p>
//           <span>awaiting payment</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{influencers.length}</p>
//           <span>influencers found</span>
//         </div>
//       </div>


//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>Influencer</th>
//               <th>Contact</th>
//               <th>Commission Rate</th>
//               <th>Referrals</th>
//               <th>Earnings</th>
//               <th>Joined</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {influencers.length > 0 ? (
//               influencers.map(influencer => (
//                 <tr key={influencer._id}>
//                   <td>
//                     {editingInfluencer === influencer._id ? (
//                       <input
//                         type="text"
//                         name="name"
//                         value={editForm.name || ''}
//                         onChange={handleInputChange}
//                         className="edit-input"
//                       />
//                     ) : (
//                       <div>
//                         <div className="influencer-name">{getSafeString(influencer.name)}</div>
//                         {influencer.referralCode && (
//                           <div className="referral-code" style={{color: '#666', fontSize: '12px', marginTop: '2px'}}>
//                             Code: {getSafeString(influencer.referralCode)}
//                           </div>
//                         )}
//                       </div>
//                     )}
//                   </td>
//                   <td>
//                     {editingInfluencer === influencer._id ? (
//                       <div>
//                         <input
//                           type="email"
//                           name="email"
//                           value={editForm.email || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Email"
//                         />
//                         <input
//                           type="text"
//                           name="phone"
//                           value={editForm.phone || ''}
//                           onChange={handleInputChange}
//                           className="edit-input"
//                           placeholder="Phone"
//                           style={{marginTop: '5px'}}
//                         />
//                       </div>
//                     ) : (
//                       <div>
//                         <div className="contact-email">{getSafeString(influencer.email)}</div>
//                         <div className="contact-phone" style={{color: '#666', fontSize: '12px', marginTop: '2px'}}>
//                           {getSafeString(influencer.phone)}
//                         </div>
//                       </div>
//                     )}
//                   </td>
//                   <td>
//                     {editingInfluencer === influencer._id ? (
//                       <select
//                         name="commissionRate"
//                         value={editForm.commissionRate || ''}
//                         onChange={handleInputChange}
//                         className="edit-select"
//                       >
//                         <option value={8}>8%</option>
//                         <option value={10}>10%</option>
//                         <option value={12}>12%</option>
//                         <option value={13}>13%</option>
//                         <option value={15}>15%</option>
//                       </select>
//                     ) : (
//                       <span className="commission-rate">{getSafeNumber(influencer.commissionRate)}%</span>
//                     )}
//                   </td>
//                   <td>
//                     <span className="referrals-count">
//                       {getSafeNumber(influencer.stats?.totalReferrals)}
//                     </span>
//                   </td>
//                   <td>
//                     <div className="earnings-info">
//                       <div className="total-earnings">Total: ₹{getSafeNumber(influencer.stats?.totalEarnings)}</div>
//                       {influencer.stats?.pendingEarnings > 0 && (
//                         <div className="pending-earnings" style={{color: '#48bb78', fontWeight: '600', fontSize: '12px', marginTop: '2px'}}>
//                           Pending: ₹{getSafeNumber(influencer.stats.pendingEarnings)}
//                         </div>
//                       )}
//                     </div>
//                   </td>
//                   <td>
//                     <span className="join-date">
//                       {formatDate(influencer.createdAt)}
//                     </span>
//                   </td>
//                   <td>
//                     <span 
//                       className={`status-badge ${influencer.isActive ? 'active' : 'inactive'}`}
//                       style={{cursor: 'pointer'}}
//                       onClick={() => handleToggleStatus(influencer)}
//                       title={`Click to ${influencer.isActive ? 'deactivate' : 'activate'}`}
//                     >
//                       {influencer.isActive ? 'Active' : 'Inactive'}
//                     </span>
//                   </td>
//                   <td>
//                     {editingInfluencer === influencer._id ? (
//                       <div className="edit-actions">
//                         <button 
//                           className="action-btn save" 
//                           onClick={handleSaveEdit}
//                           disabled={isLoading}
//                         >
//                           {isLoading ? 'Saving...' : 'Save'}
//                         </button>
//                         <button className="action-btn cancel" onClick={handleCancelEdit}>
//                           Cancel
//                         </button>
//                       </div>
//                     ) : (
//                       <div className="action-buttons">
//                         <button 
//                           className="action-btn view" 
//                           onClick={() => handleViewInfluencer(influencer)}
//                           title="View Profile"
//                         >
//                           Profile
//                         </button>
//                         <button 
//                           className="action-btn edit" 
//                           onClick={() => handleEditInfluencer(influencer)}
//                           title="Edit Influencer"
//                         >
//                           Edit
//                         </button>
//                         {influencer.stats?.pendingEarnings > 0 && (
//                           <button 
//                             className="action-btn payout" 
//                             onClick={() => handleProcessPayout(influencer)}
//                             title="Process Payout"
//                           >
//                             Payout
//                           </button>
//                         )}
//                         <button 
//                           className="action-btn delete" 
//                           onClick={() => handleDeleteInfluencer(influencer._id)}
//                           title="Delete Influencer"
//                           style={{backgroundColor: '#e53e3e'}}
//                         >
//                           Delete
//                         </button>
//                       </div>
//                     )}
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="no-data">
//                   <p>No influencers found {isFiltered ? 'matching your filters' : ''}.</p>
//                   {isFiltered && (
//                     <button className="clear-filters-link" onClick={clearFilters}>
//                       Clear filters to see all influencers
//                     </button>
//                   )}
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>


//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {influencers.length} of {totalInfluencers} influencers
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//           {isFiltered && !searchTerm && <span className="filtered-indicator"> • Filtered Results</span>}
//         </div>
//         <div className="pagination-controls">
//           <button 
//             className="pagination-btn" 
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>
          
//           <div className="page-numbers">
//             {generatePageNumbers().map(pageNumber => (
//               <button
//                 key={pageNumber}
//                 className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                 onClick={() => handlePageClick(pageNumber)}
//               >
//                 {pageNumber}
//               </button>
//             ))}
            
//             {totalPages > 5 && currentPage < totalPages - 2 && (
//               <>
//                 <span className="page-dots">...</span>
//                 <button
//                   className="page-number"
//                   onClick={() => handlePageClick(totalPages)}
//                 >
//                   {totalPages}
//                 </button>
//               </>
//             )}
//           </div>
          
//           <button 
//             className="pagination-btn" 
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>


//       {viewingInfluencer && !isFetchingDetails && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Influencer Profile - {getSafeString(viewingInfluencer.influencer?.name)}</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Influencer Name:</label>
//                   <span>{getSafeString(viewingInfluencer.influencer?.name)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Email:</label>
//                   <span>{getSafeString(viewingInfluencer.influencer?.email)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone:</label>
//                   <span>{getSafeString(viewingInfluencer.influencer?.phone)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Commission Rate:</label>
//                   <span>{getSafeNumber(viewingInfluencer.influencer?.commissionRate)}%</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Referral Code:</label>
//                   <span style={{fontWeight: 'bold', color: '#1890ff'}}>
//                     {getSafeString(viewingInfluencer.influencer?.referralCode)}
//                   </span>
//                 </div>
//                 {viewingInfluencer.influencer?.tempPassword && (
//                   <div className="detail-row">
//                     <label>Temporary Password:</label>
//                     <span style={{fontWeight: 'bold', color: '#dc2626'}}>
//                       {getSafeString(viewingInfluencer.influencer.tempPassword)}
//                     </span>
//                   </div>
//                 )}
//                 <div className="detail-row">
//                   <label>Total Referrals:</label>
//                   <span>{getSafeNumber(viewingInfluencer.stats?.totalReferrals)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Total Earnings:</label>
//                   <span>₹{getSafeNumber(viewingInfluencer.stats?.totalEarnings)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Pending Earnings:</label>
//                   <span>₹{getSafeNumber(viewingInfluencer.stats?.pendingEarnings)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Joined Date:</label>
//                   <span>{formatDate(viewingInfluencer.influencer?.createdAt)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Last Updated:</label>
//                   <span>{formatDate(viewingInfluencer.influencer?.updatedAt)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Status:</label>
//                   <span className={`status-badge ${viewingInfluencer.influencer?.isActive ? 'active' : 'inactive'}`}>
//                     {viewingInfluencer.influencer?.isActive ? 'Active' : 'Inactive'}
//                   </span>
//                 </div>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {viewingInfluencer && isFetchingDetails && <SkeletonModal />}


//       {showAddModal && (
//         <div className="modal-overlay" onClick={closeAddModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Add New Influencer</h3>
//               <button className="modal-close-btn" onClick={closeAddModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Influencer Name *</label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={newInfluencer.name}
//                     onChange={handleNewInfluencerChange}
//                     className="edit-input"
//                     placeholder="Enter influencer name"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Email *</label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={newInfluencer.email}
//                     onChange={handleNewInfluencerChange}
//                     className="edit-input"
//                     placeholder="Enter email address"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Phone *</label>
//                   <input
//                     type="text"
//                     name="phone"
//                     value={newInfluencer.phone}
//                     onChange={handleNewInfluencerChange}
//                     className="edit-input"
//                     placeholder="Enter phone number"
//                     required
//                   />
//                 </div>
//                 <div className="detail-row">
//                   <label>Commission Rate *</label>
//                   <select
//                     name="commissionRate"
//                     value={newInfluencer.commissionRate}
//                     onChange={handleNewInfluencerChange}
//                     className="edit-select"
//                     required
//                   >
//                     <option value={8}>8%</option>
//                     <option value={10}>10%</option>
//                     <option value={12}>12%</option>
//                     <option value={13}>13%</option>
//                     <option value={15}>15%</option>
//                   </select>
//                 </div>
//               </div>
//               <div style={{marginTop: '15px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '5px', fontSize: '12px', color: '#666'}}>
//                 <p style={{margin: '0'}}><strong>Note:</strong> Fields marked with * are required. The influencer will receive a referral code and temporary password upon creation.</p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closeAddModal} disabled={isLoading}>
//                 Cancel
//               </button>
//               <button 
//                 className="action-btn save" 
//                 onClick={handleAddInfluencer}
//                 disabled={isLoading || !newInfluencer.name || !newInfluencer.email || !newInfluencer.phone}
//               >
//                 {isLoading ? 'Creating...' : 'Add Influencer'}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {processingPayout && (
//         <div className="modal-overlay" onClick={closePayoutModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Process Payout</h3>
//               <button className="modal-close-btn" onClick={closePayoutModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="customer-details">
//                 <div className="detail-row">
//                   <label>Influencer:</label>
//                   <span>{getSafeString(processingPayout.name)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Referral Code:</label>
//                   <span>{getSafeString(processingPayout.referralCode)}</span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Amount to Pay:</label>
//                   <span style={{color: '#48bb78', fontWeight: '600', fontSize: '18px'}}>
//                     ₹{getSafeNumber(processingPayout.stats?.pendingEarnings)}
//                   </span>
//                 </div>
//                 <div className="detail-row">
//                   <label>Total Earnings:</label>
//                   <span>₹{getSafeNumber(processingPayout.stats?.totalEarnings)}</span>
//                 </div>
//               </div>
//               <div style={{marginTop: '20px', padding: '15px', backgroundColor: '#f0f9ff', borderRadius: '8px'}}>
//                 <p style={{margin: '0', color: '#0369a1', fontSize: '14px'}}>
//                   <strong>Note:</strong> This will process the payment and reset the pending commission to zero.
//                 </p>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="action-btn cancel" onClick={closePayoutModal}>
//                 Cancel
//               </button>
//               <button className="action-btn payout" onClick={handleConfirmPayout}>
//                 Confirm Payout
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default InfluencerManage;
import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/CustomerReport.css';       // reuse customer additions (load LAST)
import {
  createInfluencer,
  getInfluencers,
  getInfluencerById,
  updateInfluencer,
  deleteInfluencer,
  updateInfluencerStatus
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

// ---------- helpers ----------
const pad = (n) => String(n).padStart(2, '0');
const formatDateDMY = (d) => {
  if (!d) return 'N/A';
  const x = new Date(d);
  if (isNaN(x.getTime())) return 'N/A';
  return `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()}`;
};
const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 })
    .format(amount || 0);
const imgUrl = (p) => (p ? `${process.env.REACT_APP_BASE_URL}/uploads/${p}` : '');

const safeStr = (v) => (v === null || v === undefined ? '' : String(v));
const safeNum = (v) => (v === null || v === undefined ? 0 : Number(v) || 0);

// ============================================================
// Influencer card
// ============================================================
const InfluencerCard = ({ infl, index, onView, onEdit, onToggleStatus, onPayout }) => (
  <div className={`prm-card cr-card ${infl.isActive ? '' : 'inactive'}`} style={{ animationDelay: `${index * 70}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <Avatar name={infl.name} src={imgUrl(infl.profileImage)} size={52} />
        <div>
          <div className="prm-card-no">Influencer #{String(infl.serialNo).padStart(2, '0')}</div>
          <h3 className="prm-card-title">{infl.name || 'N/A'}</h3>
          <div className="prm-card-sub">
            <Icon name="calendar" size={14} /> Joined {formatDateDMY(infl.createdAt)}
          </div>
        </div>
      </div>
      <span
        className={`prm-status ${infl.isActive ? 'active' : 'inactive'}`}
        style={{ cursor: 'pointer' }}
        onClick={() => onToggleStatus(infl)}
        title={`Click to ${infl.isActive ? 'deactivate' : 'activate'}`}
      >
        {infl.isActive ? 'Active' : 'Inactive'}
      </span>
    </div>

    <div className="pbo-contact">
      <div><Icon name="mail" size={14} /> {infl.email || 'N/A'}</div>
      <div><Icon name="phone" size={14} /> {infl.phone || 'N/A'}</div>
      {infl.referralCode && (
        <div><Icon name="tag" size={14} /> Code: <b>{infl.referralCode}</b></div>
      )}
    </div>

    <div className="prm-metrics">
      <div className="prm-metric">
        <div className="v"><Icon name="tag" size={15} /> {safeNum(infl.commissionRate)}%</div>
        <div className="l">Commission</div>
      </div>
      <div className="prm-metric">
        <div className="v"><Icon name="users" size={15} /> {safeNum(infl.stats?.totalReferrals)}</div>
        <div className="l">Referrals</div>
      </div>
      <div className="prm-metric">
        <div className="v"><Icon name="wallet" size={15} /> {formatCurrency(infl.stats?.totalEarnings)}</div>
        <div className="l">Earnings</div>
      </div>
    </div>

    {safeNum(infl.stats?.pendingEarnings) > 0 && (
      <div style={{
        margin: '0 0 12px', padding: '8px 12px', borderRadius: 8,
        background: 'rgba(72,187,120,.12)', color: '#2f855a',
        fontSize: 13, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 8
      }}>
        <Icon name="wallet" size={14} /> Pending: {formatCurrency(infl.stats.pendingEarnings)}
      </div>
    )}

    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(infl)}>
        <Icon name="eye" size={14} /> Profile
      </button>
      <button className="prm-btn ghost sm" onClick={() => onEdit(infl)}>
        <Icon name="edit" size={14} /> Edit
      </button>
      {safeNum(infl.stats?.pendingEarnings) > 0 && (
        <button className="prm-btn primary sm" onClick={() => onPayout(infl)}>
          <Icon name="wallet" size={14} /> Payout
        </button>
      )}
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const InfluencerManage = () => {
  const { token } = useSelector(state => state.user);

  const [influencers, setInfluencers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [layout, setLayout] = useState('table');

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalInfluencers, setTotalInfluencers] = useState(0);
  const totalPages = Math.max(1, Math.ceil(totalInfluencers / pageSize));

  // modals
  const [viewingInfluencer, setViewingInfluencer] = useState(null);
  const [isFetchingDetails, setIsFetchingDetails] = useState(false);
  const [editing, setEditing] = useState(null);
  const [editForm, setEditForm] = useState({});
  const [saving, setSaving] = useState(false);

  const [showAddModal, setShowAddModal] = useState(false);
  const [newInfluencer, setNewInfluencer] = useState({ name: '', email: '', phone: '', commissionRate: 10 });
  const [creating, setCreating] = useState(false);

  const [processingPayout, setProcessingPayout] = useState(null);

  // ---------- fetch (debounced) ----------
  useEffect(() => {
    const t = setTimeout(fetchInfluencers, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, searchTerm]);

  const fetchInfluencers = async () => {
    try {
      setLoading(true);
      setSearching(true);
      setError(null);

      const params = { page: currentPage, limit: pageSize };
      if (searchTerm) params.search = searchTerm;

      const res = await getInfluencers(token, params);
      if (res && res.influencers) {
        setInfluencers(res.influencers.map((u, i) => ({
          ...u,
          serialNo: (currentPage - 1) * pageSize + i + 1,
          isActive: u.isActive !== undefined ? u.isActive : true,
          stats: u.stats || { totalEarnings: 0, pendingEarnings: 0, totalReferrals: 0 }
        })));
        setTotalInfluencers(res.total || res.influencers.length);
      } else {
        setInfluencers([]);
      }
    } catch (err) {
      console.error('Error fetching influencers:', err);
      setError('Failed to fetch influencers. Please try again.');
      setInfluencers([]);
    } finally {
      setLoading(false);
      setSearching(false);
      setFirstLoad(false);
    }
  };

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(totalPages);
  }, [currentPage, totalPages]);

  const visible = useMemo(() => influencers.filter(i =>
    statusFilter === 'all' ? true : statusFilter === 'active' ? i.isActive : !i.isActive
  ), [influencers, statusFilter]);

  const activeOnPage = influencers.filter(i => i.isActive).length;
  const pendingPayoutOnPage = influencers.reduce((s, i) => s + safeNum(i.stats?.pendingEarnings), 0);
  const totalEarningsOnPage = influencers.reduce((s, i) => s + safeNum(i.stats?.totalEarnings), 0);

  // ---------- handlers ----------
  const handleExportCSV = () => {
    if (influencers.length === 0) return toast.warning('No data to export');
    const headers = ['No.', 'Name', 'Email', 'Phone', 'Referral Code', 'Commission %', 'Referrals', 'Total Earnings', 'Pending Earnings', 'Status', 'Joined'];
    const rows = influencers.map(i => [
      i.serialNo, i.name || '', i.email || '', i.phone || '', i.referralCode || '',
      `${safeNum(i.commissionRate)}%`, safeNum(i.stats?.totalReferrals),
      safeNum(i.stats?.totalEarnings), safeNum(i.stats?.pendingEarnings),
      i.isActive ? 'Active' : 'Inactive', formatDateDMY(i.createdAt)
    ]);
    const csv = [headers.join(','), ...rows.map(r => r.map(f => `"${String(f ?? '').replace(/"/g, '""')}"`).join(','))].join('\n');
    const url = window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `influencers-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    toast.success('CSV exported successfully');
  };

  const handleViewInfluencer = async (infl) => {
    try {
      setIsFetchingDetails(true);
      setViewingInfluencer(infl); // show modal instantly with summary data
      const full = await getInfluencerById(infl._id, token);
      if (full) setViewingInfluencer({ ...infl, ...(full.influencer || full) });
    } catch (err) {
      console.error('Error fetching influencer details:', err);
      toast.error('Failed to load influencer details');
    } finally {
      setIsFetchingDetails(false);
    }
  };

  const openEdit = (infl) => {
    setEditing(infl);
    setEditForm({
      name: infl.name,
      email: infl.email,
      phone: infl.phone,
      commissionRate: infl.commissionRate,
      isActive: infl.isActive
    });
  };

  const handleSaveEdit = async () => {
    if (!editForm.name?.trim()) return toast.error('Name is required');
    try {
      setSaving(true);
      await updateInfluencer(editing._id, editForm, token);
      await fetchInfluencers();
      toast.success('Influencer updated successfully');
      setEditing(null);
    } catch (err) {
      console.error('Error updating influencer:', err);
      toast.error('Failed to update influencer. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleToggleStatus = async (infl) => {
    const newStatus = !infl.isActive;
    try {
      await updateInfluencerStatus(infl._id, { isActive: newStatus }, token);
      setInfluencers(prev => prev.map(x => x._id === infl._id ? { ...x, isActive: newStatus } : x));
      toast.success(`Influencer ${newStatus ? 'activated' : 'deactivated'}`);
    } catch (err) {
      console.error('Error updating influencer status:', err);
      toast.error('Failed to update influencer status');
    }
  };

  const handleDeleteInfluencer = async (id) => {
    if (!window.confirm('Are you sure you want to delete this influencer?')) return;
    try {
      await deleteInfluencer(id, token);
      await fetchInfluencers();
      toast.success('Influencer deleted successfully');
    } catch (err) {
      console.error('Error deleting influencer:', err);
      toast.error('Failed to delete influencer');
    }
  };

  const handleConfirmPayout = () => {
    setInfluencers(prev => prev.map(i =>
      i._id === processingPayout._id
        ? { ...i, stats: { ...i.stats, pendingEarnings: 0 } }
        : i
    ));
    toast.success('Payout processed successfully');
    setProcessingPayout(null);
  };

  const handleAddInfluencer = async () => {
    if (!newInfluencer.name || !newInfluencer.email || !newInfluencer.phone) {
      return toast.error('Please fill in Name, Email, and Phone');
    }
    try {
      setCreating(true);
      const res = await createInfluencer(newInfluencer, token);
      await fetchInfluencers();
      setShowAddModal(false);
      setNewInfluencer({ name: '', email: '', phone: '', commissionRate: 10 });
      toast.success(
        `Influencer created! Referral: ${res.influencer?.referralCode || '—'} | Temp PW: ${res.influencer?.tempPassword || '—'}`,
        { autoClose: 8000 }
      );
    } catch (err) {
      console.error('Error creating influencer:', err);
      const msg = err.response?.data?.message || 'Failed to create influencer.';
      toast.error(msg);
    } finally {
      setCreating(false);
    }
  };

  const handleRefresh = () => {
    setSearchTerm(''); setStatusFilter('all'); setCurrentPage(1);
    fetchInfluencers();
  };

  // ============================================================
  if (firstLoad && loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="tag" size={13} /> Influencers</span>
          <h1>Influencer Management</h1><p>Loading influencers…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="tag" size={13} /> Marketing Partners</span>
          <h1>Influencer Management</h1>
          <p>Manage your influencers, track referrals & earnings, and process commission payouts.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input
              type="text"
              placeholder="Search by name, email or phone…"
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            />
            {searchTerm && (
              <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>
            )}
          </div>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh">
            <Icon name="refresh" size={17} />
          </button>
          <button className="pbo-icon-btn" onClick={handleExportCSV} title="Export CSV">
            <Icon name="download" size={17} />
          </button>
          <button className="prm-add-btn" onClick={() => setShowAddModal(true)}>
            <span className="plus"><Icon name="plus" size={14} /></span> Add Influencer
          </button>
        </div>
      </div>

      {error && (
        <div className="cr-error">
          <Icon name="info" size={16} /> {error}
          <button className="prm-btn ghost sm" onClick={fetchInfluencers}>Retry</button>
        </div>
      )}

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="tag" tone="indigo" label="Total Influencers" value={totalInfluencers || influencers.length} hint="All marketing partners" delay={80} />
        <StatCard icon="check" tone="green" label="Active" value={activeOnPage} hint="Active on this page" delay={160} />
        <StatCard icon="wallet" tone="amber" label="Pending Payout" value={pendingPayoutOnPage} hint="Awaiting payment (page)" delay={240} />
        <StatCard icon="search" tone="cyan" label="Search Results" value={influencers.length} hint="Influencers on this page" delay={320} />
      </div>

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            {[
              ['all', 'All', influencers.length],
              ['active', 'Active', activeOnPage],
              ['inactive', 'Inactive', influencers.length - activeOnPage]
            ].map(([k, l, c]) => (
              <button key={k} className={`prm-chip ${statusFilter === k ? 'active' : ''}`} onClick={() => setStatusFilter(k)}>
                {l} <span className="count">{c}</span>
              </button>
            ))}
          </div>
          {searchTerm && <span className="prm-tag amber">Search: “{searchTerm}”</span>}
          {searching && <span className="prm-tag gray">searching…</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{visible.length}</b> of {totalInfluencers}</span>
          <div className="prm-layout-toggle">
            <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view">
              <Icon name="grid" size={17} />
            </button>
            <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view">
              <Icon name="list" size={17} />
            </button>
          </div>
        </div>
      </div>

      {/* LIST */}
      <div className={loading ? 'cr-loading' : ''}>
        {visible.length === 0 && !loading ? (
          <div className="prm-empty">
            <div className="icon">
              <Icon name={searchTerm || statusFilter !== 'all' ? 'search' : 'tag'} size={44} />
            </div>
            <h3>{searchTerm || statusFilter !== 'all' ? 'No influencers match your search' : 'No influencers yet'}</h3>
            <p>
              {searchTerm || statusFilter !== 'all'
                ? 'Try a different search term or clear the filters.'
                : 'Click “Add Influencer” to create your first marketing partner.'}
            </p>
            {(searchTerm || statusFilter !== 'all') && (
              <button className="prm-btn ghost" onClick={handleRefresh}>Clear filters</button>
            )}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {visible.map((infl, i) => (
              <InfluencerCard
                key={infl._id}
                infl={infl}
                index={i}
                onView={handleViewInfluencer}
                onEdit={openEdit}
                onToggleStatus={handleToggleStatus}
                onPayout={setProcessingPayout}
              />
            ))}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Influencer</th>
                  <th>Commission</th>
                  <th>Referrals</th>
                  <th>Earnings</th>
                  <th>Joined</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {visible.map((infl, i) => (
                  <tr key={infl._id} style={{ animationDelay: `${i * 50}ms` }}>
                    <td>{infl.serialNo}</td>
                    <td>
                      <div className="pbo-cell-owner">
                        <Avatar name={infl.name} src={imgUrl(infl.profileImage)} />
                        <div>
                          <div className="name">{safeStr(infl.name) || 'N/A'}</div>
                          <div className="sub">{safeStr(infl.email) || 'N/A'}</div>
                          {infl.referralCode && (
                            <div className="sub" style={{ color: '#1890ff' }}>Code: {infl.referralCode}</div>
                          )}
                        </div>
                      </div>
                    </td>
                    <td><span className="pbo-count">{safeNum(infl.commissionRate)}%</span></td>
                    <td><span className="pbo-count">{safeNum(infl.stats?.totalReferrals)}</span></td>
                    <td>
                      <div>
                        <div>Total: {formatCurrency(infl.stats?.totalEarnings)}</div>
                        {safeNum(infl.stats?.pendingEarnings) > 0 && (
                          <div style={{ color: '#2f855a', fontSize: 12, fontWeight: 600 }}>
                            Pending: {formatCurrency(infl.stats.pendingEarnings)}
                          </div>
                        )}
                      </div>
                    </td>
                    <td>{formatDateDMY(infl.createdAt)}</td>
                    <td>
                      <span
                        className={`prm-status ${infl.isActive ? 'active' : 'inactive'}`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleToggleStatus(infl)}
                        title={`Click to ${infl.isActive ? 'deactivate' : 'activate'}`}
                      >
                        {infl.isActive ? 'Active' : 'Inactive'}
                      </span>
                    </td>
                    <td>
                      <div className="prm-row-actions">
                        <button className="prm-btn view sm icon-only" onClick={() => handleViewInfluencer(infl)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => openEdit(infl)} title="Edit" aria-label="Edit"><Icon name="edit" size={14} /></button>
                        {safeNum(infl.stats?.pendingEarnings) > 0 && (
                          <button className="prm-btn primary sm icon-only" onClick={() => setProcessingPayout(infl)} title="Process Payout" aria-label="Process Payout"><Icon name="wallet" size={14} /></button>
                        )}
                        <button className="prm-btn ghost sm icon-only" onClick={() => handleDeleteInfluencer(infl._id)} title="Delete"><Icon name="trash" size={14} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <Pagination
        page={currentPage}
        pageSize={pageSize}
        total={totalInfluencers}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]}
        label="influencers"
      />

      {/* VIEW MODAL */}
      {viewingInfluencer && (
        <div className="prm-overlay" onClick={() => setViewingInfluencer(null)}>
          <div className="prm-form-modal pbo-fleet" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <Avatar name={viewingInfluencer.name} src={imgUrl(viewingInfluencer.profileImage)} size={52} />
                <div>
                  <h3>{viewingInfluencer.name || 'Influencer'}</h3>
                  <p>{viewingInfluencer.email || 'N/A'} · {viewingInfluencer.phone || 'N/A'}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={() => setViewingInfluencer(null)}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="pbo-mini-stats">
                <div>
                  <span>Status</span>
                  <b className={viewingInfluencer.isActive ? 'cr-ok' : 'cr-off'}>
                    {viewingInfluencer.isActive ? 'Active' : 'Inactive'}
                  </b>
                </div>
                <div><span>Commission</span><b>{safeNum(viewingInfluencer.commissionRate)}%</b></div>
                <div><span>Referral Code</span><b>{viewingInfluencer.referralCode || '—'}</b></div>
                <div><span>Joined</span><b>{formatDateDMY(viewingInfluencer.createdAt)}</b></div>
              </div>

              <div className="pbo-mini-stats" style={{ marginTop: 12 }}>
                <div><span>Total Referrals</span><b>{safeNum(viewingInfluencer.stats?.totalReferrals)}</b></div>
                <div><span>Total Earnings</span><b>{formatCurrency(viewingInfluencer.stats?.totalEarnings)}</b></div>
                <div><span>Pending Earnings</span><b>{formatCurrency(viewingInfluencer.stats?.pendingEarnings)}</b></div>
                <div><span>Last Updated</span><b>{formatDateDMY(viewingInfluencer.updatedAt)}</b></div>
              </div>

              {viewingInfluencer.tempPassword && (
                <div className="prm-tag amber" style={{ marginTop: 12 }}>
                  Temporary Password: <b>{viewingInfluencer.tempPassword}</b>
                </div>
              )}

              {isFetchingDetails && <div style={{ marginTop: 10, fontSize: 12, color: '#888' }}>Refreshing details…</div>}
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => {
                  const c = viewingInfluencer; setViewingInfluencer(null); openEdit(c);
                }}>
                  <Icon name="edit" size={15} /> Edit
                </button>
                <button className="prm-btn primary" onClick={() => setViewingInfluencer(null)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* EDIT MODAL */}
      {editing && (
        <div className="prm-overlay" onClick={() => setEditing(null)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                <div><h3>Edit influencer</h3><p>{editing.email || editing.name}</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setEditing(null)}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="prm-fgrid">
                <Field label="Name" required>
                  <input className="prm-input" value={editForm.name || ''}
                    onChange={(e) => setEditForm(p => ({ ...p, name: e.target.value }))} />
                </Field>
                <Field label="Status">
                  <select className="prm-input prm-select" value={editForm.isActive ? 'Active' : 'Inactive'}
                    onChange={(e) => setEditForm(p => ({ ...p, isActive: e.target.value === 'Active' }))}>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </Field>
                <Field label="Email">
                  <input type="email" className="prm-input" value={editForm.email || ''}
                    onChange={(e) => setEditForm(p => ({ ...p, email: e.target.value }))} />
                </Field>
                <Field label="Phone">
                  <input className="prm-input" value={editForm.phone || ''}
                    onChange={(e) => setEditForm(p => ({ ...p, phone: e.target.value }))} />
                </Field>
                <Field label="Commission Rate" full>
                  <select className="prm-input prm-select" value={editForm.commissionRate || 10}
                    onChange={(e) => setEditForm(p => ({ ...p, commissionRate: parseInt(e.target.value, 10) }))}>
                    {[8, 10, 12, 13, 15].map(v => <option key={v} value={v}>{v}%</option>)}
                  </select>
                </Field>
              </div>
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setEditing(null)}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveEdit} disabled={saving}>
                  {saving ? 'Saving…' : 'Save changes'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ADD MODAL */}
      {showAddModal && (
        <div className="prm-overlay" onClick={() => setShowAddModal(false)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="plus" size={22} /></span>
                <div><h3>Add new influencer</h3><p>They’ll receive a referral code and temporary password.</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowAddModal(false)}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="prm-fgrid">
                <Field label="Name" required>
                  <input className="prm-input" value={newInfluencer.name}
                    onChange={(e) => setNewInfluencer(p => ({ ...p, name: e.target.value }))} />
                </Field>
                <Field label="Commission Rate">
                  <select className="prm-input prm-select" value={newInfluencer.commissionRate}
                    onChange={(e) => setNewInfluencer(p => ({ ...p, commissionRate: parseInt(e.target.value, 10) }))}>
                    {[8, 10, 12, 13, 15].map(v => <option key={v} value={v}>{v}%</option>)}
                  </select>
                </Field>
                <Field label="Email" required>
                  <input type="email" className="prm-input" value={newInfluencer.email}
                    onChange={(e) => setNewInfluencer(p => ({ ...p, email: e.target.value }))} />
                </Field>
                <Field label="Phone" required>
                  <input className="prm-input" value={newInfluencer.phone}
                    onChange={(e) => setNewInfluencer(p => ({ ...p, phone: e.target.value }))} />
                </Field>
              </div>
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowAddModal(false)} disabled={creating}>Cancel</button>
                <button
                  className="prm-btn primary"
                  onClick={handleAddInfluencer}
                  disabled={creating || !newInfluencer.name || !newInfluencer.email || !newInfluencer.phone}
                >
                  {creating ? 'Creating…' : 'Add influencer'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* PAYOUT MODAL */}
      {processingPayout && (
        <div className="prm-overlay" onClick={() => setProcessingPayout(null)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="wallet" size={22} /></span>
                <div><h3>Process payout</h3><p>{processingPayout.name}</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setProcessingPayout(null)}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="pbo-mini-stats">
                <div><span>Referral Code</span><b>{processingPayout.referralCode || '—'}</b></div>
                <div><span>Total Earnings</span><b>{formatCurrency(processingPayout.stats?.totalEarnings)}</b></div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <span>Amount to pay</span>
                  <b style={{ color: '#2f855a', fontSize: 20 }}>
                    {formatCurrency(processingPayout.stats?.pendingEarnings)}
                  </b>
                </div>
              </div>
              <p style={{ marginTop: 12, fontSize: 13, color: '#0369a1', background: '#f0f9ff', padding: 12, borderRadius: 8 }}>
                <strong>Note:</strong> This will process the payment and reset the pending commission to zero.
              </p>
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setProcessingPayout(null)}>Cancel</button>
                <button className="prm-btn primary" onClick={handleConfirmPayout}>Confirm payout</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default InfluencerManage;